import { useEffect, useRef, useState } from "react";
import type { CreateGameFormProps } from "../../game-registry";

type SetupMode = "basic" | "advanced";

const SETUP_OPTIONS: readonly {
  readonly value: SetupMode;
  readonly label: string;
  readonly hint: string;
}[] = [
  {
    value: "basic",
    label: "기본",
    hint: "중앙 E5 중립 성",
  },
  {
    value: "advanced",
    label: "전략 배치",
    hint: "선공이 중립 성 선택",
  },
];

export function GreatKingdomCreateGameForm({
  onConfigChange,
}: CreateGameFormProps) {
  const [setupMode, setSetupMode] = useState<SetupMode>("basic");
  const onConfigChangeRef = useRef(onConfigChange);
  onConfigChangeRef.current = onConfigChange;

  useEffect(() => {
    onConfigChangeRef.current({ setupMode: "basic" });
  }, []);

  function handleSetupModeChange(nextMode: SetupMode): void {
    setSetupMode(nextMode);
    onConfigChange({ setupMode: nextMode });
  }

  return (
    <section className="rounded-md border border-border-subtle bg-surface-secondary p-3">
      <div className="mb-3">
        <div className="font-semibold text-sm text-text-primary">
          그레이트 킹덤 설정
        </div>
        <div className="mt-1 text-text-muted text-xs">
          중립 성 위치를 정하고 9x9 보드에서 영토를 완성합니다.
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {SETUP_OPTIONS.map((option) => (
          <button
            type="button"
            key={option.value}
            data-testid={`great-kingdom-setup-${option.value}`}
            className={`rounded-md border px-3 py-2 text-left transition-colors ${
              setupMode === option.value
                ? "border-text-primary bg-text-primary text-white"
                : "border-border-primary bg-surface-primary text-text-secondary"
            }`}
            onClick={() => handleSetupModeChange(option.value)}
          >
            <span className="block font-semibold text-sm">{option.label}</span>
            <span className="mt-1 block text-xs opacity-80">{option.hint}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
